var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5037H1.4V4.20368H3.2165C3.2165 4.20368 3.6988 3.57647 4.7355 2.80367H0.7C0.514348 2.80367 0.336301 2.87742 0.205025 3.0087C0.0737498 3.13998 0 3.31802 0 3.50367L0 11.2037C0 11.3893 0.0737498 11.5674 0.205025 11.6987C0.336301 11.8299 0.514348 11.9037 0.7 11.9037H11.2C11.3857 11.9037 11.5637 11.8299 11.695 11.6987C11.8263 11.5674 11.9 11.3893 11.9 11.2037V8.58147L10.5 9.73298V10.5037ZM9.3527 5.63868V8.12437L14 4.48368L9.3527 0.984375V3.17607C3.71 3.17607 3.71 8.75367 3.71 8.75367C5.3074 6.13007 6.2902 5.63868 9.3527 5.63868Z",
    fill: "#3B58FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportBlueIcon);
export default __webpack_public_path__ + "static/media/export-blue-icon.182a7cc32c91851569ea0071c990f7a1.svg";
export { ForwardRef as ReactComponent };